import React from 'react';
import { HeadingContentfulModel } from 'src/api/models/Heading';
import { TrustedByContentfulModel } from '../../api/models/TrustedBy';
import Heading from '../../elements/typography/heading';
import { TrustedByContainer } from './trustedBy.styles';
import FadeInAnimationWrapper from 'src/elements/animation/fade-in/FadeInAnimationWrapper';
import TrustedByLogos from './trustedByLogos';

export interface TrustedByProps {
  heading: HeadingContentfulModel;
  logos: TrustedByContentfulModel['contentfulchildren'];
}

const TrustedBy = ({ heading, logos }: TrustedByProps): JSX.Element => {
  return (
    <TrustedByContainer>
      <FadeInAnimationWrapper transitionTimeSeconds={0.5}>
        <Heading
          text={heading.text}
          size="2.5em"
          align="center"
        />
        <TrustedByLogos logos={logos} />
      </FadeInAnimationWrapper>
    </TrustedByContainer>
  )
}

export default TrustedBy;
